import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import {config, LOG_OUT} from '../../constants';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import {Button, Input, message} from 'antd';
import {EditOutlined,} from '@ant-design/icons';


export default class AddOrUpdateSanctionListComponent extends React.Component {

    constructor(props) {
        super(props);

        const sanctionListID = this.props.match.params.sanctionListID
        const pageMode = sanctionListID ? "update" : "add";

        this.state = {
            pageMode: pageMode,
            sanctionListID: sanctionListID,
            sanctionList: {name:{}}
        }

        if (this.state.pageMode == "update") {
            axios.get(config.API_URL + "sanction-list/" + this.state.sanctionListID, {headers: authHeader()}).then(response => {
                
                const x = response.data

                console.log(x)
                
                x["nameEn"] = (x.name || {}).en 
                x["shortNameEn"] = (x.shortName || {}).en 
                x["nameTr"] = (x.name || {}).tr
                x["shortNameTr"] = (x.shortName || {}).tr
                x["nameAr"] = (x.name || {}).ar
                x["shortNameAr"] = (x.shortName || {}).ar

                this.setState({sanctionList: x})

            })
        }

    }

    addSanctionList = () => {
        const {nameEn, nameTr, shortNameEn, shortNameTr, flag, source, nameAr, shortNameAr} = this.state.sanctionList;

        let name =  {"translations":{"en": nameEn, "tr": nameTr, "ar":nameAr}};
        let shortName = {"translations":{"en": shortNameEn, "tr": shortNameTr, "ar": shortNameAr}};

        const sanctionList = {name, shortName, flag, source}

        AuthService.addSanctionList(sanctionList).then(
            response => {
                let success = response.data;

                if (success) {

                    axios.get(config.API_URL + "api-cache-clear/cacheOfSanctionListsUi", {headers: authHeader()}).then(
                        response => {
                            let success = response.data;

                            if (success){
                                window.location = "/sanction-list-controller";
                            }
                            else {
                                message.error(i18n.t('global_error'));
                            }
                        }
                    )
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)
                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )

    }

    updateSanctionList = () => {
        const {nameEn, nameTr, shortNameEn, shortNameTr, nameAr, shortNameAr, flag} = this.state.sanctionList;

        let name =  {"translations":{"en": nameEn, "tr": nameTr, "ar": nameAr}};
        let shortName = {"translations":{"en": shortNameEn, "tr": shortNameTr, "ar": shortNameAr}};

        const sanctionList = {name, shortName, flag};

        AuthService.updateSanctionList(sanctionList, this.state.sanctionListID).then(
            response => {
                let success = response.data;
                if (success) {

                    axios.get(config.API_URL + "api-cache-clear/cacheOfSanctionListsUi", {headers: authHeader()}).then(
                        response => {
                            let success = response.data;

                            if (success){
                                window.location = "/sanction-list-controller";
                            }
                            else {
                                message.error(i18n.t('global_error'));
                            }
                        }
                    )
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }


    handleInputChange = (e) => {
        const {name, value} = e.target

        this.setState(prevState => ({
            sanctionList: {
                ...prevState.sanctionList,
                [name]: value
            }
        }))

    }


    render() {

        return (

            <>
                <section className="user-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-user custom-ant-input-wrapper">
                                <div>
                                    <form method="POST" action="">
                            
                                        {this.state.pageMode == "update" ?
                                        <>
                                        <h3 style={{textAlign:"center"}}>Source: {this.state.sanctionList.source}</h3>
                                        <br/>
                                        </>
                                        :
                                        <></>
                                        }


                                        {this.state.pageMode == "add" ? <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.source}
                                                name="source"
                                                placeholder={i18n.t('sanction_list_input_source')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div> : <></>}

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.flag}
                                                name="flag"
                                                placeholder={i18n.t('sanction_list_input_flag')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <h3 style={{textAlign:"center"}}>EN</h3>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.nameEn}
                                                name="nameEn"
                                                placeholder={i18n.t('sanction_list_input_name')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.shortNameEn}
                                                name="shortNameEn"
                                                placeholder={i18n.t('sanction_list_input_shortName')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <h3 style={{textAlign:"center"}}>TR</h3>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.nameTr}
                                                name="nameTr"
                                                placeholder={i18n.t('sanction_list_input_name')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.shortNameTr}
                                                name="shortNameTr"
                                                placeholder={i18n.t('sanction_list_input_shortName')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <h3 style={{textAlign:"center"}}>AR</h3>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.nameAr}
                                                name="nameAr"
                                                placeholder={i18n.t('sanction_list_input_name')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <div className='form-box-user-input'>
                                            <Input
                                                type="text"
                                                value={this.state.sanctionList.shortNameAr}
                                                name="shortNameAr"
                                                placeholder={i18n.t('sanction_list_input_shortName')}
                                                autoComplete="off"
                                                prefix={<EditOutlined/>}
                                                onInput={this.handleInputChange}
                                            />
                                        </div>

                                        <Button
                                            className="custom-button"
                                            type="button"
                                            onClick={this.state.pageMode == "update" ? this.updateSanctionList : this.addSanctionList}
                                        >
                                            {this.state.pageMode == "update" ? i18n.t('update_sanction_list') : i18n.t('add_sanction_list')}
                                        </Button>

                                    </form>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </>

        );

    }

}